module.exports = __webpack_public_path__ + "static/media/newsec-logo.05a4bd45.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/PageLayout/newsec-logo.png
// module id = 1022
// module chunks = 0